import React, { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Alert,
  Col,
  Row,
  Spinner,
} from "reactstrap";
import { useApi } from "../Api/ApiContext";
import { useAsync } from "react-use";
import Layout, { Main } from "../Layout";

const Terms = () => {
  const { getTerms } = useApi();
  const { value: terms, loading, error } = useAsync(() => getTerms());
  const [open, setOpen] = useState("1");

  if (loading) {
    return (
      <Layout>
        <Main>
          <Row className={"justify-content-center"}>
            <Col xs={2} className="mx-auto">
              <Spinner color={"danger"} />
            </Col>
          </Row>
        </Main>
      </Layout>
    );
  }
  if (error) {
    return (
      <Layout backPath={{ pathname: "/" }}>
        <Main>
          <Alert color={"danger"}>
            <h1 className={"fs-4"}>Une erreur est survenue.</h1>
            <p>
              Nos équipes sont mobilisées pour rétablir le service dans les
              meilleurs délai.
            </p>
          </Alert>
        </Main>
      </Layout>
    );
  }
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <Layout backPath={{ pathname: "/" }}>
      <Main className={"my-4"}>
        <h1 className={"fs-1 fw-bold"}>
          Nos conditions générales d'utilisation et de vente.
        </h1>
        <Accordion className={"accordion mt-4"} open={open} toggle={toggle}>
          {terms.map((term, index) => (
            <AccordionItem key={index}>
              <AccordionHeader targetId={term.id}>
                <b>{term.name}</b>
              </AccordionHeader>
              <AccordionBody accordionId={term.id}>
                <div dangerouslySetInnerHTML={{ __html: term.content }} />
              </AccordionBody>
            </AccordionItem>
          ))}
        </Accordion>
      </Main>
    </Layout>
  );
};

export default Terms;
